import FieldsPermissions from './FieldsPermissions';

export default FieldsPermissions;
